import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}/permissions']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateESignatureRequestPermissions = async ({ eSignatureRequestId, userIds }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/e-signature-requests/${eSignatureRequestId}/permissions`, { userIds });
  return response.data;
};

export default updateESignatureRequestPermissions;
